// src/components/TestimonialSection.jsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";

// Swiper styles
import "swiper/css";

const testimonials = [
  {
    id: 1,
    name: "Nguyễn Văn Hùng",
    location: "TP. Hồ Chí Minh",
    image: "/assets/img/testimonial/av1.webp",
    text: "Design24 đã biến ý tưởng ban đầu thành một sản phẩm hoàn chỉnh, hiện đại và giàu tính sáng tạo. Chúng tôi đánh giá cao sự tận tâm cùng phong cách làm việc chuyên nghiệp của đội ngũ.",
    rating: 4.5,
  },
  {
    id: 2,
    name: "Trần Thị Mai",
    location: "TP. Cần Thơ",
    image: "/assets/img/testimonial/av2.webp",
    text: "Đội ngũ Design24 làm việc nhanh chóng, tận tình và luôn lắng nghe nhu cầu của khách hàng. Sản phẩm bàn giao vừa đẹp mắt vừa thể hiện đúng tinh thần thương hiệu của chúng tôi.",
    rating: 4.5,
  },
  {
    id: 3,
    name: "Phạm Quang Dũng",
    location: "TP. Cần Thơ",
    image: "/assets/img/testimonial/av1.webp",
    text: "Dự án cuối cùng mang lại nhiều bất ngờ tích cực. Thiết kế tinh tế, trải nghiệm người dùng mượt mà, đáp ứng tốt mục tiêu ban đầu và còn vượt ngoài mong đợi của cả tập thể, tạo nên một giá trị bền vững lâu dài.",
    rating: 5,
  },
];

// Render sao động
const renderStars = (rating) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 !== 0;

  for (let i = 0; i < fullStars; i++) stars.push(<FaStar key={`star-${i}`} />);
  if (hasHalf) stars.push(<FaStarHalfAlt key="star-half" />);
  return stars;
};

const TestimonialSection = () => {
  return (
    <section className="testimonial-section fix section-bg section-padding">
      <div className="container">
        {/* Section Title */}
        <div className="section-title text-center">
          <h6 className="wow fadeInUp">Phản Hồi</h6>
          <h2
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            Khách Hàng <span>Nói Gì</span>
          </h2>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          loop
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          breakpoints={{
            0: { slidesPerView: 1 }, // Mobile
            768: { slidesPerView: 2 }, // Tablet & PC
          }}
          className="testimonial-slider"
        >
          {testimonials.map(({ id, name, location, image, text, rating }) => (
            <SwiperSlide key={id}>
              <div className="testimonial-box-items">
                {/* Client Info */}
                <div className="client-info">
                  <div className="client-img">
                    <img
                      className=" rounded"
                      src={image}
                      alt={name}
                    />
                  </div>
                  <div className="content">
                    <h2 className="content-heading">{name}</h2>
                    <span>{location}</span>
                  </div>
                </div>

                {/* Feedback */}
                <p>{text}</p>

                {/* Bottom (Stars + Quote) */}
                <div className="testi-bottom">
                  <div className="star">{renderStars(rating)}</div>
                  <div className="quote-icon">
                    <img
                      src="/assets/img/testimonial/quote.png"
                      alt="quote"
                    />
                  </div>
                </div>

                {/* Decorative Icon */}
                <div className="icon">
                  <img
                    src="/assets/img/testimonial/icon.png"
                    alt="icon"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default TestimonialSection;
